<router-outlet (activate)="onActivate($event)"></router-outlet>
@if (!isActivated) {
  <app-splash-icon></app-splash-icon>
}
